export default __webpack_public_path__ + "static/media/flame.7c5f5669.svg";